module.exports = __webpack_public_path__ + "assets/weglot.c6683ef9.svg";